<template>
    <div class="thing-container">
        <div
                :style="styleTags"
                :id="thingId"
                ref="thing"
        >
            <!-- This will automatically be filled with content from thing-to-html -->
        </div>
    </div>
</template>

<script>
    import thingToHTML from 'thing-to-html'

    export default {
        data() {
            let id = 'tth-';
            let idCharacters = '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ';
            let idCharactersLength = idCharacters.length;

            for (let i = 0; i < 12; i++) {
                let idIndex = Math.floor(Math.random() * idCharactersLength);

                id += idCharacters[idIndex];
            }

            return {
                thingId: id
            }
        },
        props: {
            thing: {
                required: true
            },
            theme: {
                type: String,
                required: false,
                default: 'dark',
            },
            button: {
                type: Boolean,
                required: false,
                default: false
            },
            background: {
                type: String,
                required: false,
                default: '#272822'
            },
            padding: {
                type: String,
                required: false,
                default: '30px'
            }
        },
        watch: {
            thing(newThing, oldThing) {
                this.thing = newThing

                this.clear()
                this.draw()
            }
        },
        computed: {
            styleTags() {
                return {
                    background: this.background,
                    padding: this.padding
                }
            }
        },
        methods: {
            clear() {
                let thing = this.$refs.thing

                while (thing.firstChild) {
                    thing.removeChild(thing.firstChild)
                }
            },
            draw() {
                console.log();
                let thingToHTMLOptions = {
                    thing: this.thing,
                    container: '#' + this.$refs.thing.id,
                    button: this.button,
                    theme: this.theme
                }

                thingToHTML(thingToHTMLOptions)
            }
        },
        mounted() {
            this.draw()
        }
    }
</script>

<style lang="less">
    @import "~@less/font-sizes.less";
    @import "~thing-to-html/thing.css";

    .thing-container {

        .thing {
            display: block;
            overflow-y: auto;
            font-size: @app-font-size-thing-to-html-thing;
            padding: 10px;
        }
    }
</style>